import { NavLink } from "react-router-dom";
import "./Navbar.css";

// iconos
import { ReactComponent as GastosIcon } from "../../../../assets/img/icons/cajadown.svg";

const Navbar = ({ onLogout }) => {
  return (
    <nav className="navbar navbar-custom">
      <div className="navbar-title">CashFlow</div>

      <div className="navbar-icons">
        <NavLink to="/caja" className={({ isActive }) => isActive ? "nav-icon active" : "nav-icon"}>
          <svg width="24" height="24" fill="currentColor">
            <path d="M3 5h18v14H3V5zm2 2v10h14V7H5zm5 3h4v2h-4v-2z" />
          </svg>
          <span>Caja</span>
        </NavLink>

        <NavLink to="/ventas" className={({ isActive }) => isActive ? "nav-icon active" : "nav-icon"}>
          <svg width="24" height="24" fill="currentColor">
            <path d="M6 6h15l-1.5 9H7.5L6 6zm1 11a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm10 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
          </svg>
          <span>Pedidos</span>
        </NavLink>

        <NavLink to="/pagos" className={({ isActive }) => isActive ? "nav-icon active" : "nav-icon"}>
          <svg width="24" height="24" fill="currentColor">
            <path d="M6 2h12a2 2 0 012 2v18l-4-2-4 2-4-2-4 2V4a2 2 0 012-2z" />
          </svg>
          <span>Ventas</span>
        </NavLink>

        <NavLink to="/gastos" className={({ isActive }) => isActive ? "nav-icon active" : "nav-icon"}>
          <GastosIcon className="icon" />
          <span>Gastos</span>
        </NavLink>

        <NavLink to="/inventario" className={({ isActive }) => isActive ? "nav-icon active" : "nav-icon"}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M3 9V21H21V9L12 3L3 9ZM5 11H19V19H5V11ZM9 13V17H11V13H9ZM13 13V17H15V13H13ZM7 13V15H9V13H7Z" />
          </svg>
          <span>Inventario</span>
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;